/** Удаление аккаунта текущего пользователя. */
import { useMutation } from "@tanstack/react-query";
import { Api } from "@/api";
import { usersKeys } from "./keys";

export const useDeleteCurrentUser = () => {
	const mutation = useMutation({
		mutationFn: Api.User.deleteApiUsersMe,
		mutationKey: usersKeys.deleteMe,
	});

	return { execute: mutation.mutateAsync, isPending: mutation.isPending };
};
